/** @jsx dom */
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var propTypes = {
	'class': {
		type: 'string'
	},
	collapsed: {
		type: 'boolean'
	},
	items: {
		type: 'array'
	},
	multiple: {
		type: 'boolean'
	},
	onClick: {
		type: 'function'
	}
};

var initialState = function initialState() {
	return {
		active: []
	};
};

var handleSetActive = function handleSetActive(obj, _ref, onClick, setState) {
	var el = _ref.el;
	var i = _ref.i;

	setState(obj);

	if (onClick) {
		onClick(obj.active, _extends({}, el, { i: i, isOpen: obj.active.indexOf(i) !== -1 }));
	}
};

var setActive = function setActive(i, _ref2, _ref3, setState) {
	var el = _ref2.el;
	var multiple = _ref2.multiple;
	var onClick = _ref2.onClick;
	var active = _ref3.active;
	return function () {
		var index = active.indexOf(i);

		if (!multiple) {
			if (index !== -1) {
				handleSetActive({ active: [] }, { el: el, i: i }, onClick, setState);
				return;
			}

			handleSetActive({ active: [i] }, { el: el, i: i }, onClick, setState);
			return;
		}

		if (index !== -1) {
			active.splice(index, 1);
			handleSetActive({ active: active }, { el: el, i: i }, onClick, setState);
			return;
		}

		active.push(i);
		handleSetActive({ active: active }, { el: el, i: i }, onClick, setState);
	};
};

var getElements = function getElements(_ref4, _ref5, setState) {
	var items = _ref4.items;
	var multiple = _ref4.multiple;
	var onClick = _ref4.onClick;
	var active = _ref5.active;
	return items.map(function (el, i) {
		return (0, _magicVirtualElement2['default'])(
			'div',
			{ 'class': ['Accordion-element', { 'Accordion-element--active': active.indexOf(i) > -1 }] },
			(0, _magicVirtualElement2['default'])(
				'div',
				{ 'class': 'Accordion-heading', onClick: setActive(i, { el: el, multiple: multiple, onClick: onClick }, { active: active }, setState) },
				el.heading
			),
			(0, _magicVirtualElement2['default'])(
				'div',
				{ 'class': 'Accordion-content' },
				el.content
			)
		);
	});
};

var setItems = function setItems(_ref6, setState) {
	var items = _ref6.items;
	var multiple = _ref6.multiple;

	var active = [];

	items.forEach(function (el, i) {
		if (!el.active) {
			return;
		}

		if (!multiple) {
			active = [i];
			return;
		}

		active.push(i);
	});

	setState({ active: active });
};

var afterMount = function afterMount(_ref7, el, setState) {
	var props = _ref7.props;
	return setItems(props, setState);
};
var afterUpdate = function afterUpdate(_ref8, prevProps, prevState, setState) {
	var props = _ref8.props;
	return !(0, _deepEqual2['default'])(props, prevProps) && setItems(props, setState);
};

var render = function render(_ref9, setState) {
	var props = _ref9.props;
	var state = _ref9.state;

	return (0, _magicVirtualElement2['default'])(
		'div',
		{ 'class': ['Accordion', props['class']] },
		getElements(props, state, setState)
	);
};

exports['default'] = { afterMount: afterMount, afterUpdate: afterUpdate, initialState: initialState, propTypes: propTypes, render: render };
module.exports = exports['default'];
